import { Component } from '@angular/core';
import { BaseModalComponent } from '../../../core/modals/components/base-modal/base-modal.component';

@Component({
  selector: 'app-disclaimer-modal',
  templateUrl: './disclaimer-modal.component.html',
  styleUrls: ['./disclaimer-modal.component.scss'],
})
export class DisclaimerModalComponent extends BaseModalComponent<{}> {}
